import { useState } from 'react';
import { errorMessage } from '@/api/error-text';
import { useSession } from '@/api/session';
import { de } from '@/i18n/de';
import { Button } from '@/shell/ui/button';
import { useToast } from '@/shell/ui/toast';

/**
 * Violettes Dauerbanner im Demo-Modus ([A] 5.9): „Du siehst Beispieldaten.“ mit dem Weg zurück zu den eigenen
 * Daten. Im Live-Modus erscheint nichts.
 */
export function DemoBanner() {
  const { me, setMode } = useSession();
  const { toast } = useToast();
  const [busy, setBusy] = useState(false);
  if (me?.mode !== 'demo') {
    return null;
  }

  async function back() {
    setBusy(true);
    try {
      await setMode('live');
    } catch (error) {
      toast({ message: errorMessage(error) });
    } finally {
      setBusy(false);
    }
  }

  return (
    <section
      aria-label={de.demo.region}
      className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 bg-demo px-4 py-2 text-on-demo"
    >
      <p className="text-body font-semibold">{de.demo.banner}</p>
      <Button
        variant="secondary"
        onClick={() => void back()}
        {...(busy ? { disabledReason: de.demo.switching } : {})}
      >
        {de.demo.back}
      </Button>
    </section>
  );
}
